<template>
	<div class="income-history">
		<div class="block" style="display: flex;">
			<div @click="onMouseOver()" class="year">
				<el-date-picker
				  clear-icon="''"
				  :prefix-icon = "prefixyearimg"
				  v-model="year"
				  type="year"
				  placeholder="year"
				  :picker-options="setDisabledyear"
				  value-format="yyyy"
				  @change="selectyear"
				  >
				</el-date-picker>
			</div>
		    <div class="month" @click="onmonthMouse()">  
				<el-date-picker
				  ref="datepicke"
				  clear-icon="11"
				  :prefix-icon = "prefiximg"
				  v-model="month"
				  type="month"
				  popper-class="due_month"
				  style="margin-left: 20px;"
				  placeholder=""
				  :format="monthval"
				  :picker-options="setDisabledmonth"
				  @change="selcetmonth"
				  >
				</el-date-picker>
			</div>
			<span style="position: absolute;left: 149px;top: 9px;">{{monthone}}</span>
			<el-button class="seabut" @click="search()">Search</el-button>
		</div>
		<div class="echarts">
			<div class="left">
				<div style="font-size: 17px;" >Month Income</div>
				<div class="showmoney">$  {{adjust(income,2)}}</div>
			</div>
			<div class="right" v-show="earthsstatus">
				<div class="rightEcharts" id="rightEcharts"></div>
			</div>
		</div>
	</div>
</template>

<script>
	import { apiGetIncomeDetailByMonth} from '../common/api/workincome.js'
	export default{
		data(){
			return{
				year:"",//选择的年份
				month:"",//选择的月份
				beginTime:"",//开始时间
				income:"",
				setDisabledyear: {
					disabledDate: (time) => {
					        var date = new Date();
							var year = date.getFullYear();
					        var month = date.getMonth() ;
					        if (month >= 1 && month <= 9) {
					            month = "0" + month;
					        }
					        var currentdate = year.toString()  + month.toString();
					 
					        var timeyear = time.getFullYear();
					        var timemonth = time.getMonth() + 1;
					        if (timemonth >= 1 && timemonth <= 9) {
					            timemonth = "0" + timemonth;
					        }
					        var timedate = timeyear.toString() + timemonth.toString();
							
					        return currentdate < timedate;
					}
				},
				setDisabledmonth:{
					disabledDate: (time) => {
					        var date = new Date();
							var year = date.getFullYear();
					        var month = date.getMonth() ;
					        if (month >= 1 && month <= 9) {
					            month = "0" + month;
					        }
					        var currentdate = year.toString()  + month.toString();
					 
					        var timeyear = time.getFullYear();
					        var timemonth = time.getMonth() + 1;
					        if (timemonth >= 1 && timemonth <= 9) {
					            timemonth = "0" + timemonth;
					        }
					        var timedate = timeyear.toString() + timemonth.toString();
							if(this.year==year){
								return currentdate < timedate;
							}
					        return 
					}
				},
				option:{
					title: {
						text: '',
					    // 副标题
					    subtext: "Month Income",
					    // 主副标题间距
					    itemGap: 10,
					    x: 'center',
					    y: 'center',
					    top: '110',
					    // 主标题样式
					    textStyle: {
					        fontSize: '20',
					        color: 'black'
					    },
					    // 副标题样式
					    subtextStyle: {
					        fontSize: '12',
					        fontWeight: '600',
					        color: 'black'
					    }
					    },
				    tooltip: {
				        trigger: 'item',

				    },
					color:['#FF69B4','#FFC0CB','#FF8900','#36B9CC','#9400D3','#7B68EE','#00FF00'],
				    legend: {
				        top: '18%',  
						// right:90,
						left:"74%",
						itemWidth: 10,   // 设置图例图形的宽
						itemHeight: 10,
						borderRadius:9,
						orient: 'vertical',
						data:['Revenue','Profit','Special Bonus','Completion Bonus','Updating Bonus','Signing Bonus','Channel Income']
				    },
				    series: [
				        {
				            name: 'Income',
				            type: 'pie',
				            radius: ['30%','50%'],	// 设置环形饼状图， 第一个百分数设置内圈大小，第二个百分数设置外圈大小
							center: ['50%', '35%'],  // 设置饼状图位置，第一个百分数调水平位置，第二个百分数调垂直位置
				            avoidLabelOverlap: false,
				            itemStyle: {
				                borderRadius: 0,
				                borderColor: '#fff',
				                borderWidth: 3
				            },  
				            label: {
				                show: false,
				                position: 'center',
								// normal: {
								// 		// show: true,
								// 		position: 'center',
								// 		color:'#9A9EBA',
								// 		formatter: '',
								//  },
								// emphasis: {//中间文字显示
								// 	show: true,
								// 	}
				            },
				    //         emphasis: {
				    //             label: {
				    //                 show: true,
				    //                 fontSize: '18',
				    //                 fontWeight: 'bold'
				    //             },
								
				    //         },
				            labelLine: {
				                show: false
				            },
							tooltip: {
							        trigger: 'item',
							        formatter: function(arg){
										arg.value = Number(arg.value)
										return arg.name+': '+parseFloat((arg.value).toFixed(2)).toLocaleString('en',{ minimumFractionDigits: 2 })
									}
							     },
				            data: [
				                {value: 1048.00, name: 'Revenue'},
				                {value: 735.00, name: 'Profit'},
				                {value: 580.00, name: 'Special Bonus'},
				                {value: 484.00, name: 'Completion Bonus'},
				                {value: 300.00, name: 'Updating Bonus'},
				                {value: 300.00, name: 'Signing Bonus'},
				                {value: 300.00, name: 'Channel Income'}
				            ],
							minAngle: 5,  // 最小的扇区角度（0 ~ 360），用于防止某个值过小导致扇区太小影响交互
							avoidLabelOverlap: true,   // 是否启用防止标签重叠策略
				        }
				    ]
				},
				list:[],
				monthval:"",
				monthone:"",
				prefiximg:"el-icon-caret-bottom",
				prefixyearimg:"el-icon-caret-bottom",
				earthsstatus:true,//饼形图是否展示
		  }
		},
		
		created(){
			//获取上一个月
			this.year = new Date().getFullYear().toString()
			// this.month = new Date(new Date().setMonth((new Date().getMonth()-1)))
			var date = new Date()
			this.month = new Date(date.getFullYear(), date.getMonth() - 1, 1) // 上月第一天
			this.beginTime = this.month
			this.monthone =  this.month.toString().slice(4,7)
			this.getMonthdetail(this.beginTime)
		},
		mounted() {
			this.$nextTick(() => {
			        setTimeout(()=>{//弹框嵌套图表-请求数据有延迟
			            this.loadEacharts()
			        },500);
			    });
			//控制时间选择器图标
			// let keyNode = document.querySelector(".el-date-editor");
				
			// let iNode = document.createElement("i");
			// iNode.setAttribute("class", "el-icon-caret-bottom"); // el-icon-bottom
			// keyNode.appendChild(iNode);
			
			// iNode.style.position = "absolute";
			// iNode.style.top = "13px";
			// iNode.style.right = "10px";
			// var list = document.getElementsByClassName('el-icon-caret-bottom')
			// list.onclick = this.checkPicker()
			// this.loadEacharts()
		},
		methods:{
			checkPicker() {
			      // document
			      //   .querySelector(".time-date-picker")
			      //   .querySelector("input")
			      //   .focus();
			      this.$refs.datepicke.focus();
			    },
			//年选择器点击
			onMouseOver(){
			    this.prefixyearimg = 'el-icon-caret-top'
			},
			//月选择器点击
			onmonthMouse(){
				this.prefiximg = 'el-icon-caret-top'
			},
			
			//查询数据
			getMonthdetail(val){
				val = new Date(val.getTime() + 24*60*60*1000);
				let data={
					data:{
						userId: this.$store.state.userInfo == undefined ? 0 : this.$store.state.userInfo.id,
						beginTime:val
					}
				}
				apiGetIncomeDetailByMonth(data).then(res=>{
					if(res.code == 0){
						this.list = res.data
						this.income = res.data.income==0?'0.00':this.adjust(res.data.income,2)
						this.$nextTick(() => {
						   this.option.title.text = '$' + '' + this.income
						   this.option.series[0].data[0].value = res.data.revenue==0?null:this.adjust(res.data.revenue,2)
						   // this.option.series[0].data[0].name = res.data.revenue==0?'':'Revenue'
						   this.option.series[0].data[1].value = res.data.profit ==0?null:this.adjust(res.data.profit,2)
						   // this.option.series[0].data[1].name = res.data.profit ==0?'':'Profit'
						   this.option.series[0].data[2].value = res.data.specialBonus == 0?null:this.adjust(res.data.specialBonus,2)
						   // this.option.series[0].data[2].name = res.data.specialBonus == 0?'':'Special Bonus'
						   this.option.series[0].data[3].value = res.data.completionBonus == 0?null:this.adjust(res.data.completionBonus,2)
						   // this.option.series[0].data[3].name = res.data.completionBonus == 0?'':'Completion Bonus'
						   this.option.series[0].data[4].value = res.data.dailyUpdateBonus == 0?null:this.adjust(res.data.dailyUpdateBonus,2)
						   // this.option.series[0].data[4].name = res.data.dailyUpdateBonus == 0?'':'Updating Bonus'
						   this.option.series[0].data[5].value = res.data.signingBonus == 0?null:this.adjust(res.data.signingBonus,2)
						   // this.option.series[0].data[5].name = res.data.signingBonus == 0?null:'Signing Bonus'
						   this.option.series[0].data[6].value = null
						   // this.option.series[0].data[6].name = null
						   if(res.data.revenue==0 && res.data.profit ==0 && res.data.specialBonus==0 && res.data.completionBonus ==0
								&& res.data.dailyUpdateBonus ==0 && res.data.signingBonus==0){
									this.earthsstatus = false
								}
							else{
								this.earthsstatus = true
							}
						   this.loadEacharts()
						});
						this.$emit('Income-click', res.data)
					}
				})
			},
			
			//选择年
			selectyear(){
				this.prefixyearimg= 'el-icon-caret-bottom'
			},
			//选择了月份
			selcetmonth(){
				this.prefiximg = 'el-icon-caret-bottom'
				// 替换指定位置的字符
				const replaceStr = (str, index, char) => {
				 return str.substring(0, index) + char + str.substring(index + 4);
				}
				if(this.month){
					this.beginTime = new Date(replaceStr(this.month.toString(),11,this.year))
				} else {
					//清空时间
				}
				this.monthone = this.month.toString().slice(4,7)
			},
			datescreen(name){
				switch(name){
					case '01':
						return 'Jan'
						break;
					case '02':
						return 'Feb'
						break;
					case '03':
						return 'Mar'
						break;
					case '04':
						return 'Apr'
						break;
					case '05':
						return 'May'
						break;
					case '06':
						return 'Jun'
						break;
					case '07':
						return 'Jul'
						break;
					case '08':
						return 'Aug'
						break;
					case '09':
						return 'Sep'
						break;
					case '10':
						return 'Oct'
						break;
					case '11':
						return 'Nov'
						break;
					case '12':
						return 'Dec'
						break;
				}
			},
			//四舍五入
			adjust(numberRound,roundDigit){
			  if (numberRound>=0){
			  var tempNumber = parseInt((numberRound * Math.pow(10,roundDigit)+0.5))/Math.pow(10,roundDigit);
			  tempNumber += ''
			  if (!/\./.test(tempNumber)) {
			      tempNumber += '.00'
			  }
			  var arrayNum = tempNumber.split('.')
			  if (arrayNum[1].length < 2) {
			     tempNumber += '0'
			  }
			  return tempNumber;
			  } else{
			  var numberRound1=-numberRound;
			  var tempNumber = parseInt((numberRound1 * Math.pow(10,roundDigit)+0.5))/Math.pow(10,roundDigit);
			  return -tempNumber;
			
			  }
			},
			//搜索查询
			search(){
				this.$emit("showlist",false)
				this.getMonthdetail(this.beginTime)
			},
			loadEacharts(){
				let bingChart = this.$echarts.init(document.getElementById('rightEcharts'))
				bingChart.setOption(this.option)
			},
			//修改时间样式
			formatDate(Time) { //获得UTC的时间
				const moment = require('moment-timezone');
				if (Time == null) {
					return null
				}
				var timezone = "Asia/Shanghai";
				const clean = moment(Time).format('YYYY-MM-DD'); // 清除 timezone 信息
				const Shanghailocal = moment.tz(clean, timezone);
				return Shanghailocal.tz('UTC').format('YYYY-MM-DD')
			},
			// 获取当前日期的上一个月
			getlastMonth() {
			    let now = new Date();
			    // 当前月的日期
			    let nowDate = now.getDate();
			    let lastMonth = new Date(now.getTime());
			    // 设置上一个月（这里不需要减1）
			    lastMonth.setMonth(lastMonth.getMonth());
			    // 设置为0，默认为当前月的最后一天
			    lastMonth.setDate(0);
			    // 上一个月的天数
			    let daysOflastMonth = lastMonth.getDate();
			    // 设置上一个月的日期，如果当前月的日期大于上个月的总天数，则为最后一天 
			    lastMonth.setDate(nowDate > daysOflastMonth ? daysOflastMonth : nowDate);
			    return lastMonth;
			}

			
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.income-history{
		.block{
				padding-left: 20px;
				.el-date-editor.el-input{
					width: 100px;
				}
				.month{
					/deep/.el-input__inner {
					  padding-left: 10px; 
					  font-size: 0px;
					}
				}
				// /deep/.el-input__inner {
				//   padding-left: 10px; 
				//   font-size: 0px;
				// }
				.seabut{
					border: 0px solid red;
					border-radius: 5px;
					background: antiquewhite;
					color: coral;
					height: 40px;
					margin-left: 30px;
				}
			}
			.echarts{
				display: flex;
				flex-direction: row;
				justify-content: space-between;
				margin-top: 10px;
				.left{
					width: 30%;
					padding: 20px 0px 20px 35px;
					/* flex: 1; */
					/* padding-left: 30px; */
					/* padding-top: 20px; */
					.showmoney{
						padding-top: 15px;
						font-size: 30px;
						font-weight: 600;
						color: black;
					}
				}
				.right{
					/* flex: 0 0 60%; */
					/* flex: 1; */
					height: 300px;
					background-color: #FFFFFF;
					border-radius: 5px;
					/* padding: 15px -30px 10px 20px; */
					width: 90%;
					// margin-right: 30px;
					.rightEcharts{
						width: auto;
						height: 400px;
					}
				}
			}
	}
</style>
<style lang="scss">
	.due_month .el-date-picker__header{
	    display: none;
	}
	.year{
		.el-date-editor {
		    .el-input__prefix {
		       position: absolute;
		        left: 70px; // left根据实际情况定值
		        top: 0;
		     }
		     input {
		       padding-left: 15px;
		     }
		}
	}
	.month{
		.el-date-editor {
		    .el-input__prefix {
		       position: absolute;
		        left: 70px; // left根据实际情况定值
		        top: 0;
		     }
		     input {
		       padding-left: 282px;
		     }
		}
	}

	
</style>